/**
 * Auto-generated TypeScript route types for api routes
 *
 * DO NOT EDIT THIS FILE MANUALLY!
 * Run 'php artisan routes:generate-types --prefix=api' to regenerate
 */
import type { AxiosRequestConfig } from 'axios';

import type { Result } from './api-shared';
import { createApiRequest } from './api-shared';

type APIRoute_admin_activityLogs_list = {
  readonly name: 'api.admin.activityLogs.list';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_api_type_descriptors_list = {
  readonly name: 'api.admin.api_type_descriptors.list';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_api_types_list = {
  readonly name: 'api.admin.api_types.list';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_brands_activity_log_list = {
  readonly name: 'api.admin.brands.activity_log.list';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_callback_audit_index = {
  readonly name: 'api.admin.brands.callback_audit.index';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_callback_tests_documentation = {
  readonly name: 'api.admin.brands.callback_tests.documentation';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_callback_tests_index = {
  readonly name: 'api.admin.brands.callback_tests.index';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_callback_tests_results_show = {
  readonly name: 'api.admin.brands.callback_tests.results.show';
  readonly method: 'get';
  readonly params?: { brandId: string | number; runId: string | number };
};

type APIRoute_admin_brands_callback_tests_run = {
  readonly name: 'api.admin.brands.callback_tests.run';
  readonly method: 'post';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_callback_tests_runs_index = {
  readonly name: 'api.admin.brands.callback_tests.runs.index';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_callback_urls_create = {
  readonly name: 'api.admin.brands.callback_urls.create';
  readonly method: 'post';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_callback_urls_delete = {
  readonly name: 'api.admin.brands.callback_urls.delete';
  readonly method: 'delete';
  readonly params?: { brandId: string | number; brandCallbackUrlId: string | number };
};

type APIRoute_admin_brands_callback_urls_list = {
  readonly name: 'api.admin.brands.callback_urls.list';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_callback_urls_secrets_activate = {
  readonly name: 'api.admin.brands.callback_urls.secrets.activate';
  readonly method: 'post';
  readonly params?: { brandId: string | number; brandCallbackUrlId: string | number; brandCallbackSecretId: string | number };
};

type APIRoute_admin_brands_callback_urls_secrets_delete = {
  readonly name: 'api.admin.brands.callback_urls.secrets.delete';
  readonly method: 'delete';
  readonly params?: { brandId: string | number; brandCallbackUrlId: string | number; brandCallbackSecretId: string | number };
};

type APIRoute_admin_brands_callback_urls_secrets_generate = {
  readonly name: 'api.admin.brands.callback_urls.secrets.generate';
  readonly method: 'post';
  readonly params?: { brandId: string | number; brandCallbackUrlId: string | number };
};

type APIRoute_admin_brands_callback_urls_update = {
  readonly name: 'api.admin.brands.callback_urls.update';
  readonly method: 'put';
  readonly params?: { brandId: string | number; brandCallbackUrlId: string | number };
};

type APIRoute_admin_brands_countries_currencies = {
  readonly name: 'api.admin.brands.countries_currencies';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_create = {
  readonly name: 'api.admin.brands.create';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_admin_brands_credentials_delete = {
  readonly name: 'api.admin.brands.credentials.delete';
  readonly method: 'delete';
  readonly params?: { brandId: string | number; brandCredentialId: string | number };
};

type APIRoute_admin_brands_credentials_generate = {
  readonly name: 'api.admin.brands.credentials.generate';
  readonly method: 'post';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_credentials_list = {
  readonly name: 'api.admin.brands.credentials.list';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_credentials_update = {
  readonly name: 'api.admin.brands.credentials.update';
  readonly method: 'put';
  readonly params?: { brandId: string | number; brandCredentialId: string | number };
};

type APIRoute_admin_brands_currencies_update = {
  readonly name: 'api.admin.brands.currencies.update';
  readonly method: 'post';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_delete = {
  readonly name: 'api.admin.brands.delete';
  readonly method: 'delete';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_games_export = {
  readonly name: 'api.admin.brands.games.export';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_games_list = {
  readonly name: 'api.admin.brands.games.list';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_games_toggle = {
  readonly name: 'api.admin.brands.games.toggle';
  readonly method: 'post';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_list = {
  readonly name: 'api.admin.brands.list';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_brands_preview_move_impact = {
  readonly name: 'api.admin.brands.preview_move_impact';
  readonly method: 'post';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_provider_credentials_bulk_delete = {
  readonly name: 'api.admin.brands.provider_credentials.bulk_delete';
  readonly method: 'post';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_provider_credentials_debug = {
  readonly name: 'api.admin.brands.provider_credentials.debug';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_provider_credentials_defaults = {
  readonly name: 'api.admin.brands.provider_credentials.defaults';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_provider_credentials_delete = {
  readonly name: 'api.admin.brands.provider_credentials.delete';
  readonly method: 'delete';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_provider_credentials_effective = {
  readonly name: 'api.admin.brands.provider_credentials.effective';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_provider_credentials_generate_idn_live_operator_ids = {
  readonly name: 'api.admin.brands.provider_credentials.generate_idn_live_operator_ids';
  readonly method: 'post';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_provider_credentials_incomplete = {
  readonly name: 'api.admin.brands.provider_credentials.incomplete';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_provider_credentials_index = {
  readonly name: 'api.admin.brands.provider_credentials.index';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_provider_credentials_overrides = {
  readonly name: 'api.admin.brands.provider_credentials.overrides';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_provider_credentials_parse_csv = {
  readonly name: 'api.admin.brands.provider_credentials.parse_csv';
  readonly method: 'post';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_provider_credentials_save = {
  readonly name: 'api.admin.brands.provider_credentials.save';
  readonly method: 'post';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_provider_credentials_schema = {
  readonly name: 'api.admin.brands.provider_credentials.schema';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_providers_export = {
  readonly name: 'api.admin.brands.providers.export';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_providers_list = {
  readonly name: 'api.admin.brands.providers.list';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_providers_update = {
  readonly name: 'api.admin.brands.providers.update';
  readonly method: 'post';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_show = {
  readonly name: 'api.admin.brands.show';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_brands_update = {
  readonly name: 'api.admin.brands.update';
  readonly method: 'put';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_callback_api_documentation = {
  readonly name: 'api.admin.callback_api.documentation';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_companies_activity_logs = {
  readonly name: 'api.admin.companies.activity_logs';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_admin_companies_api_types_preview_impact = {
  readonly name: 'api.admin.companies.api_types.preview_impact';
  readonly method: 'post';
  readonly params?: { companyId: string | number };
};

type APIRoute_admin_companies_api_types_show = {
  readonly name: 'api.admin.companies.api_types.show';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_admin_companies_api_types_update = {
  readonly name: 'api.admin.companies.api_types.update';
  readonly method: 'put';
  readonly params?: { companyId: string | number };
};

type APIRoute_admin_companies_assignable_roles = {
  readonly name: 'api.admin.companies.assignable_roles';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_admin_companies_available_customers = {
  readonly name: 'api.admin.companies.available_customers';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_admin_companies_create = {
  readonly name: 'api.admin.companies.create';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_admin_companies_customer_permissions = {
  readonly name: 'api.admin.companies.customer_permissions';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_companies_customers_attach = {
  readonly name: 'api.admin.companies.customers.attach';
  readonly method: 'post';
  readonly params?: { companyId: string | number };
};

type APIRoute_admin_companies_customers_detach = {
  readonly name: 'api.admin.companies.customers.detach';
  readonly method: 'delete';
  readonly params?: { companyId: string | number; customerId: string | number };
};

type APIRoute_admin_companies_customers_list = {
  readonly name: 'api.admin.companies.customers.list';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_admin_companies_customers_update = {
  readonly name: 'api.admin.companies.customers.update';
  readonly method: 'patch';
  readonly params?: { companyId: string | number; customerId: string | number };
};

type APIRoute_admin_companies_delete = {
  readonly name: 'api.admin.companies.delete';
  readonly method: 'delete';
  readonly params?: { companyId: string | number };
};

type APIRoute_admin_companies_invitations_destroy = {
  readonly name: 'api.admin.companies.invitations.destroy';
  readonly method: 'delete';
  readonly params?: { companyId: string | number; companyInvitationId: string | number };
};

type APIRoute_admin_companies_invitations_index = {
  readonly name: 'api.admin.companies.invitations.index';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_admin_companies_invitations_resend = {
  readonly name: 'api.admin.companies.invitations.resend';
  readonly method: 'post';
  readonly params?: { companyId: string | number; companyInvitationId: string | number };
};

type APIRoute_admin_companies_invitations_store = {
  readonly name: 'api.admin.companies.invitations.store';
  readonly method: 'post';
  readonly params?: { companyId: string | number };
};

type APIRoute_admin_companies_list = {
  readonly name: 'api.admin.companies.list';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_companies_roles_destroy = {
  readonly name: 'api.admin.companies.roles.destroy';
  readonly method: 'delete';
  readonly params?: { companyId: string | number; roleId: string | number };
};

type APIRoute_admin_companies_roles_store = {
  readonly name: 'api.admin.companies.roles.store';
  readonly method: 'post';
  readonly params?: { companyId: string | number };
};

type APIRoute_admin_companies_roles_update = {
  readonly name: 'api.admin.companies.roles.update';
  readonly method: 'put';
  readonly params?: { companyId: string | number; roleId: string | number };
};

type APIRoute_admin_companies_show = {
  readonly name: 'api.admin.companies.show';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_admin_companies_update = {
  readonly name: 'api.admin.companies.update';
  readonly method: 'put';
  readonly params?: { companyId: string | number };
};

type APIRoute_admin_companies_users_permissions_update = {
  readonly name: 'api.admin.companies.users.permissions.update';
  readonly method: 'patch';
  readonly params?: { companyId: string | number; customerId: string | number };
};

type APIRoute_admin_companies_users_roles_update = {
  readonly name: 'api.admin.companies.users.roles.update';
  readonly method: 'patch';
  readonly params?: { companyId: string | number; customerId: string | number };
};

type APIRoute_admin_companies_users_show = {
  readonly name: 'api.admin.companies.users.show';
  readonly method: 'get';
  readonly params?: { companyId: string | number; customerId: string | number };
};

type APIRoute_admin_countries_index = {
  readonly name: 'api.admin.countries.index';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_currencies_index = {
  readonly name: 'api.admin.currencies.index';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_customers_users_destroy = {
  readonly name: 'api.admin.customers.users.destroy';
  readonly method: 'delete';
  readonly params?: { customerId: string | number };
};

type APIRoute_admin_customers_users_index = {
  readonly name: 'api.admin.customers.users.index';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_customers_users_show = {
  readonly name: 'api.admin.customers.users.show';
  readonly method: 'get';
  readonly params?: { customerId: string | number };
};

type APIRoute_admin_customers_users_store = {
  readonly name: 'api.admin.customers.users.store';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_admin_customers_users_update = {
  readonly name: 'api.admin.customers.users.update';
  readonly method: 'put';
  readonly params?: { customerId: string | number };
};

type APIRoute_admin_dashboard_gaming_analytics = {
  readonly name: 'api.admin.dashboard.gaming_analytics';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_dashboard_geo_performance = {
  readonly name: 'api.admin.dashboard.geo_performance';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_dashboard_top_games = {
  readonly name: 'api.admin.dashboard.top_games';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_dashboard_top_providers = {
  readonly name: 'api.admin.dashboard.top_providers';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_discount_programs_delete = {
  readonly name: 'api.admin.discount_programs.delete';
  readonly method: 'delete';
  readonly params?: { discountProgramId: string | number };
};

type APIRoute_admin_discount_programs_index = {
  readonly name: 'api.admin.discount_programs.index';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_discount_programs_preview = {
  readonly name: 'api.admin.discount_programs.preview';
  readonly method: 'post';
  readonly params?: { discountProgramId: string | number };
};

type APIRoute_admin_discount_programs_show = {
  readonly name: 'api.admin.discount_programs.show';
  readonly method: 'get';
  readonly params?: { discountProgramId: string | number };
};

type APIRoute_admin_discount_programs_store = {
  readonly name: 'api.admin.discount_programs.store';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_admin_discount_programs_update = {
  readonly name: 'api.admin.discount_programs.update';
  readonly method: 'put';
  readonly params?: { discountProgramId: string | number };
};

type APIRoute_admin_docs_index = {
  readonly name: 'api.admin.docs.index';
  readonly method: 'get';
  readonly params?: { docType: string | number; version: string | number };
};

type APIRoute_admin_docs_section = {
  readonly name: 'api.admin.docs.section';
  readonly method: 'get';
  readonly params?: { docType: string | number; version: string | number; filename: string | number };
};

type APIRoute_admin_docs_versions = {
  readonly name: 'api.admin.docs.versions';
  readonly method: 'get';
  readonly params?: { docType: string | number };
};

type APIRoute_admin_employees_roles_assign_employees = {
  readonly name: 'api.admin.employees.roles.assign_employees';
  readonly method: 'post';
  readonly params?: { roleId: string | number };
};

type APIRoute_admin_employees_roles_destroy = {
  readonly name: 'api.admin.employees.roles.destroy';
  readonly method: 'delete';
  readonly params?: { roleId: string | number };
};

type APIRoute_admin_employees_roles_index = {
  readonly name: 'api.admin.employees.roles.index';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_employees_roles_permissions = {
  readonly name: 'api.admin.employees.roles.permissions';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_employees_roles_remove_employee = {
  readonly name: 'api.admin.employees.roles.remove_employee';
  readonly method: 'delete';
  readonly params?: { roleId: string | number; employeeId: string | number };
};

type APIRoute_admin_employees_roles_show = {
  readonly name: 'api.admin.employees.roles.show';
  readonly method: 'get';
  readonly params?: { roleId: string | number };
};

type APIRoute_admin_employees_roles_store = {
  readonly name: 'api.admin.employees.roles.store';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_admin_employees_roles_update = {
  readonly name: 'api.admin.employees.roles.update';
  readonly method: 'put';
  readonly params?: { roleId: string | number };
};

type APIRoute_admin_employees_users_destroy = {
  readonly name: 'api.admin.employees.users.destroy';
  readonly method: 'delete';
  readonly params?: { employeeId: string | number };
};

type APIRoute_admin_employees_users_index = {
  readonly name: 'api.admin.employees.users.index';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_employees_users_permissions_update = {
  readonly name: 'api.admin.employees.users.permissions.update';
  readonly method: 'patch';
  readonly params?: { employeeId: string | number };
};

type APIRoute_admin_employees_users_roles_update = {
  readonly name: 'api.admin.employees.users.roles.update';
  readonly method: 'patch';
  readonly params?: { employeeId: string | number };
};

type APIRoute_admin_employees_users_show = {
  readonly name: 'api.admin.employees.users.show';
  readonly method: 'get';
  readonly params?: { employeeId: string | number };
};

type APIRoute_admin_employees_users_store = {
  readonly name: 'api.admin.employees.users.store';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_admin_employees_users_update = {
  readonly name: 'api.admin.employees.users.update';
  readonly method: 'put';
  readonly params?: { employeeId: string | number };
};

type APIRoute_admin_exchangeRates_list = {
  readonly name: 'api.admin.exchangeRates.list';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_game_sessions_show = {
  readonly name: 'api.admin.game_sessions.show';
  readonly method: 'get';
  readonly params?: { sessionId: string | number };
};

type APIRoute_admin_games_create = {
  readonly name: 'api.admin.games.create';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_admin_games_delete = {
  readonly name: 'api.admin.games.delete';
  readonly method: 'delete';
  readonly params?: { gameId: string | number };
};

type APIRoute_admin_games_export = {
  readonly name: 'api.admin.games.export';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_games_list = {
  readonly name: 'api.admin.games.list';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_games_show = {
  readonly name: 'api.admin.games.show';
  readonly method: 'get';
  readonly params?: { gameId: string | number };
};

type APIRoute_admin_games_update = {
  readonly name: 'api.admin.games.update';
  readonly method: 'put';
  readonly params?: { gameId: string | number };
};

type APIRoute_admin_invoices_aging = {
  readonly name: 'api.admin.invoices.aging';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_invoices_commissions_alerts = {
  readonly name: 'api.admin.invoices.commissions.alerts';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_invoices_commissions_list = {
  readonly name: 'api.admin.invoices.commissions.list';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_invoices_commissions_update = {
  readonly name: 'api.admin.invoices.commissions.update';
  readonly method: 'put';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_invoices_discounts_create = {
  readonly name: 'api.admin.invoices.discounts.create';
  readonly method: 'post';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_invoices_discounts_delete = {
  readonly name: 'api.admin.invoices.discounts.delete';
  readonly method: 'delete';
  readonly params?: { discountId: string | number };
};

type APIRoute_admin_invoices_discounts_update = {
  readonly name: 'api.admin.invoices.discounts.update';
  readonly method: 'put';
  readonly params?: { discountId: string | number };
};

type APIRoute_admin_invoices_export = {
  readonly name: 'api.admin.invoices.export';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_invoices_index = {
  readonly name: 'api.admin.invoices.index';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_invoices_lock_update = {
  readonly name: 'api.admin.invoices.lock.update';
  readonly method: 'patch';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_invoices_payment_update = {
  readonly name: 'api.admin.invoices.payment.update';
  readonly method: 'patch';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_invoices_preview = {
  readonly name: 'api.admin.invoices.preview';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_invoices_show = {
  readonly name: 'api.admin.invoices.show';
  readonly method: 'get';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_invoices_structure = {
  readonly name: 'api.admin.invoices.structure';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_invoices_template_update = {
  readonly name: 'api.admin.invoices.template.update';
  readonly method: 'patch';
  readonly params?: { brandId: string | number };
};

type APIRoute_admin_launcher_domains_create = {
  readonly name: 'api.admin.launcher_domains.create';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_admin_launcher_domains_delete = {
  readonly name: 'api.admin.launcher_domains.delete';
  readonly method: 'delete';
  readonly params?: { launcherDomainId: string | number };
};

type APIRoute_admin_launcher_domains_index = {
  readonly name: 'api.admin.launcher_domains.index';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_launcher_domains_retry = {
  readonly name: 'api.admin.launcher_domains.retry';
  readonly method: 'post';
  readonly params?: { launcherDomainId: string | number };
};

type APIRoute_admin_launcher_domains_status = {
  readonly name: 'api.admin.launcher_domains.status';
  readonly method: 'get';
  readonly params?: { launcherDomainId: string | number };
};

type APIRoute_admin_launcher_domains_toggle_status = {
  readonly name: 'api.admin.launcher_domains.toggle_status';
  readonly method: 'patch';
  readonly params?: { launcherDomainId: string | number };
};

type APIRoute_admin_launcher_domains_update = {
  readonly name: 'api.admin.launcher_domains.update';
  readonly method: 'put';
  readonly params?: { launcherDomainId: string | number };
};

type APIRoute_admin_mainProviders_list = {
  readonly name: 'api.admin.mainProviders.list';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_mainProviders_show = {
  readonly name: 'api.admin.mainProviders.show';
  readonly method: 'get';
  readonly params?: { mainProviderId: string | number };
};

type APIRoute_admin_mainProviders_update = {
  readonly name: 'api.admin.mainProviders.update';
  readonly method: 'put';
  readonly params?: { mainProviderId: string | number };
};

type APIRoute_admin_organizations_create = {
  readonly name: 'api.admin.organizations.create';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_admin_organizations_delete = {
  readonly name: 'api.admin.organizations.delete';
  readonly method: 'delete';
  readonly params?: { organizationId: string | number };
};

type APIRoute_admin_organizations_index = {
  readonly name: 'api.admin.organizations.index';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_organizations_show = {
  readonly name: 'api.admin.organizations.show';
  readonly method: 'get';
  readonly params?: { organizationId: string | number };
};

type APIRoute_admin_organizations_update = {
  readonly name: 'api.admin.organizations.update';
  readonly method: 'put';
  readonly params?: { organizationId: string | number };
};

type APIRoute_admin_players_game_sessions = {
  readonly name: 'api.admin.players.game_sessions';
  readonly method: 'get';
  readonly params?: { playerId: string | number };
};

type APIRoute_admin_players_games = {
  readonly name: 'api.admin.players.games';
  readonly method: 'get';
  readonly params?: { playerId: string | number };
};

type APIRoute_admin_players_lifetime_stats = {
  readonly name: 'api.admin.players.lifetime_stats';
  readonly method: 'get';
  readonly params?: { playerId: string | number };
};

type APIRoute_admin_players_list = {
  readonly name: 'api.admin.players.list';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_players_mark_as_demo = {
  readonly name: 'api.admin.players.mark_as_demo';
  readonly method: 'post';
  readonly params?: { playerId: string | number };
};

type APIRoute_admin_players_show = {
  readonly name: 'api.admin.players.show';
  readonly method: 'get';
  readonly params?: { playerId: string | number };
};

type APIRoute_admin_providerCredentials_types = {
  readonly name: 'api.admin.providerCredentials.types';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_providers_brands = {
  readonly name: 'api.admin.providers.brands';
  readonly method: 'get';
  readonly params?: { providerId: string | number };
};

type APIRoute_admin_providers_export = {
  readonly name: 'api.admin.providers.export';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_providers_list = {
  readonly name: 'api.admin.providers.list';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_providers_show = {
  readonly name: 'api.admin.providers.show';
  readonly method: 'get';
  readonly params?: { providerId: string | number };
};

type APIRoute_admin_providers_update = {
  readonly name: 'api.admin.providers.update';
  readonly method: 'put';
  readonly params?: { providerId: string | number };
};

type APIRoute_admin_public_api_documentation = {
  readonly name: 'api.admin.public_api.documentation';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_public_api_endpoints = {
  readonly name: 'api.admin.public_api.endpoints';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_public_api_test = {
  readonly name: 'api.admin.public_api.test';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_admin_reports_gambling_summary_export = {
  readonly name: 'api.admin.reports.gambling_summary.export';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_admin_reports_gambling_summary_index = {
  readonly name: 'api.admin.reports.gambling_summary.index';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_reports_games_index = {
  readonly name: 'api.admin.reports.games.index';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_reports_games_trend = {
  readonly name: 'api.admin.reports.games.trend';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_reports_players_export = {
  readonly name: 'api.admin.reports.players.export';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_admin_reports_players_index = {
  readonly name: 'api.admin.reports.players.index';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_reports_promotions_export = {
  readonly name: 'api.admin.reports.promotions.export';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_admin_reports_promotions_index = {
  readonly name: 'api.admin.reports.promotions.index';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_search = {
  readonly name: 'api.admin.search';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_transactions_audit_logs = {
  readonly name: 'api.admin.transactions.audit_logs';
  readonly method: 'get';
  readonly params?: { transactionId: string | number };
};

type APIRoute_admin_transactions_cancel = {
  readonly name: 'api.admin.transactions.cancel';
  readonly method: 'post';
  readonly params?: { transactionId: string | number };
};

type APIRoute_admin_transactions_dashboard = {
  readonly name: 'api.admin.transactions.dashboard';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_transactions_details = {
  readonly name: 'api.admin.transactions.details';
  readonly method: 'get';
  readonly params?: { transactionId: string | number };
};

type APIRoute_admin_transactions_index = {
  readonly name: 'api.admin.transactions.index';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_transactions_player = {
  readonly name: 'api.admin.transactions.player';
  readonly method: 'get';
  readonly params?: { playerId: string | number };
};

type APIRoute_admin_transactions_recent = {
  readonly name: 'api.admin.transactions.recent';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_transactions_reports_generate = {
  readonly name: 'api.admin.transactions.reports.generate';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_admin_transactions_retry = {
  readonly name: 'api.admin.transactions.retry';
  readonly method: 'post';
  readonly params?: { transactionId: string | number };
};

type APIRoute_admin_transactions_round_details_url = {
  readonly name: 'api.admin.transactions.round_details_url';
  readonly method: 'get';
  readonly params?: { transactionId: string | number };
};

type APIRoute_admin_transactions_stats = {
  readonly name: 'api.admin.transactions.stats';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_translation_overrides_all_language_codes = {
  readonly name: 'api.admin.translation_overrides.all_language_codes';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_translation_overrides_available_keys = {
  readonly name: 'api.admin.translation_overrides.available_keys';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_translation_overrides_available_locales = {
  readonly name: 'api.admin.translation_overrides.available_locales';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_translation_overrides_create_locale = {
  readonly name: 'api.admin.translation_overrides.create_locale';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_admin_translation_overrides_delete = {
  readonly name: 'api.admin.translation_overrides.delete';
  readonly method: 'delete';
  readonly params?: { translationOverrideId: string | number };
};

type APIRoute_admin_translation_overrides_delete_locale = {
  readonly name: 'api.admin.translation_overrides.delete_locale';
  readonly method: 'delete';
  readonly params?: null;
};

type APIRoute_admin_translation_overrides_disable_locale = {
  readonly name: 'api.admin.translation_overrides.disable_locale';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_admin_translation_overrides_enable_locale = {
  readonly name: 'api.admin.translation_overrides.enable_locale';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_admin_translation_overrides_list = {
  readonly name: 'api.admin.translation_overrides.list';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_admin_translation_overrides_upsert = {
  readonly name: 'api.admin.translation_overrides.upsert';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_auth_check_sensitive = {
  readonly name: 'api.auth.check.sensitive';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_auth_confirm_sensitive = {
  readonly name: 'api.auth.confirm.sensitive';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_auth_login = {
  readonly name: 'api.auth.login';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_auth_logout = {
  readonly name: 'api.auth.logout';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_auth_refresh = {
  readonly name: 'api.auth.refresh';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_auth_two_fa_backup_codes_generate = {
  readonly name: 'api.auth.two_fa.backup_codes.generate';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_auth_two_fa_backup_codes_index = {
  readonly name: 'api.auth.two_fa.backup_codes.index';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_auth_two_fa_devices_create = {
  readonly name: 'api.auth.two_fa.devices.create';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_auth_two_fa_devices_delete = {
  readonly name: 'api.auth.two_fa.devices.delete';
  readonly method: 'delete';
  readonly params?: { otpDeviceId: string | number };
};

type APIRoute_auth_two_fa_devices_index = {
  readonly name: 'api.auth.two_fa.devices.index';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_auth_two_fa_devices_verify = {
  readonly name: 'api.auth.two_fa.devices.verify';
  readonly method: 'post';
  readonly params?: { otpDeviceId: string | number };
};

type APIRoute_auth_two_fa_verify = {
  readonly name: 'api.auth.two_fa.verify';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_auth_user_activity_logs = {
  readonly name: 'api.auth.user.activity_logs';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_auth_user_email_update = {
  readonly name: 'api.auth.user.email.update';
  readonly method: 'patch';
  readonly params?: null;
};

type APIRoute_auth_user_email_verify = {
  readonly name: 'api.auth.user.email.verify';
  readonly method: 'post';
  readonly params?: null;
};

type APIRoute_auth_user_locale_update = {
  readonly name: 'api.auth.user.locale.update';
  readonly method: 'patch';
  readonly params?: null;
};

type APIRoute_auth_user_login_logs = {
  readonly name: 'api.auth.user.login_logs';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_auth_user_password_update = {
  readonly name: 'api.auth.user.password.update';
  readonly method: 'patch';
  readonly params?: null;
};

type APIRoute_auth_user_sessions_index = {
  readonly name: 'api.auth.user.sessions.index';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_auth_user_sessions_revoke = {
  readonly name: 'api.auth.user.sessions.revoke';
  readonly method: 'delete';
  readonly params?: { personalAccessTokenId: string | number };
};

type APIRoute_auth_user_show = {
  readonly name: 'api.auth.user.show';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_auth_user_timezone_update = {
  readonly name: 'api.auth.user.timezone.update';
  readonly method: 'patch';
  readonly params?: null;
};

type APIRoute_callback_api_documentation = {
  readonly name: 'api.callback_api.documentation';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_customer_activity_log_list = {
  readonly name: 'api.customer.activity_log.list';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_api_type_descriptors_list = {
  readonly name: 'api.customer.api_type_descriptors.list';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_assignable_roles = {
  readonly name: 'api.customer.assignable_roles';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_brands_activity_log_list = {
  readonly name: 'api.customer.brands.activity_log.list';
  readonly method: 'get';
  readonly params?: { companyId: string | number; brandId: string | number };
};

type APIRoute_customer_brands_callback_audit_index = {
  readonly name: 'api.customer.brands.callback_audit.index';
  readonly method: 'get';
  readonly params?: { companyId: string | number; brandId: string | number };
};

type APIRoute_customer_brands_callback_tests_documentation = {
  readonly name: 'api.customer.brands.callback_tests.documentation';
  readonly method: 'get';
  readonly params?: { companyId: string | number; brandId: string | number };
};

type APIRoute_customer_brands_callback_tests_index = {
  readonly name: 'api.customer.brands.callback_tests.index';
  readonly method: 'get';
  readonly params?: { companyId: string | number; brandId: string | number };
};

type APIRoute_customer_brands_callback_tests_results_show = {
  readonly name: 'api.customer.brands.callback_tests.results.show';
  readonly method: 'get';
  readonly params?: { companyId: string | number; brandId: string | number; runId: string | number };
};

type APIRoute_customer_brands_callback_tests_run = {
  readonly name: 'api.customer.brands.callback_tests.run';
  readonly method: 'post';
  readonly params?: { companyId: string | number; brandId: string | number };
};

type APIRoute_customer_brands_callback_tests_runs_index = {
  readonly name: 'api.customer.brands.callback_tests.runs.index';
  readonly method: 'get';
  readonly params?: { companyId: string | number; brandId: string | number };
};

type APIRoute_customer_brands_callback_urls_create = {
  readonly name: 'api.customer.brands.callback_urls.create';
  readonly method: 'post';
  readonly params?: { companyId: string | number; brandId: string | number };
};

type APIRoute_customer_brands_callback_urls_delete = {
  readonly name: 'api.customer.brands.callback_urls.delete';
  readonly method: 'delete';
  readonly params?: { companyId: string | number; brandId: string | number; brandCallbackUrlId: string | number };
};

type APIRoute_customer_brands_callback_urls_list = {
  readonly name: 'api.customer.brands.callback_urls.list';
  readonly method: 'get';
  readonly params?: { companyId: string | number; brandId: string | number };
};

type APIRoute_customer_brands_callback_urls_secrets_activate = {
  readonly name: 'api.customer.brands.callback_urls.secrets.activate';
  readonly method: 'post';
  readonly params?: { companyId: string | number; brandId: string | number; brandCallbackUrlId: string | number; brandCallbackSecretId: string | number };
};

type APIRoute_customer_brands_callback_urls_secrets_delete = {
  readonly name: 'api.customer.brands.callback_urls.secrets.delete';
  readonly method: 'delete';
  readonly params?: { companyId: string | number; brandId: string | number; brandCallbackUrlId: string | number; brandCallbackSecretId: string | number };
};

type APIRoute_customer_brands_callback_urls_secrets_generate = {
  readonly name: 'api.customer.brands.callback_urls.secrets.generate';
  readonly method: 'post';
  readonly params?: { companyId: string | number; brandId: string | number; brandCallbackUrlId: string | number };
};

type APIRoute_customer_brands_callback_urls_update = {
  readonly name: 'api.customer.brands.callback_urls.update';
  readonly method: 'put';
  readonly params?: { companyId: string | number; brandId: string | number; brandCallbackUrlId: string | number };
};

type APIRoute_customer_brands_countries_currencies = {
  readonly name: 'api.customer.brands.countries_currencies';
  readonly method: 'get';
  readonly params?: { companyId: string | number; brandId: string | number };
};

type APIRoute_customer_brands_credentials_delete = {
  readonly name: 'api.customer.brands.credentials.delete';
  readonly method: 'delete';
  readonly params?: { companyId: string | number; brandId: string | number; brandCredentialId: string | number };
};

type APIRoute_customer_brands_credentials_generate = {
  readonly name: 'api.customer.brands.credentials.generate';
  readonly method: 'post';
  readonly params?: { companyId: string | number; brandId: string | number };
};

type APIRoute_customer_brands_credentials_list = {
  readonly name: 'api.customer.brands.credentials.list';
  readonly method: 'get';
  readonly params?: { companyId: string | number; brandId: string | number };
};

type APIRoute_customer_brands_credentials_update = {
  readonly name: 'api.customer.brands.credentials.update';
  readonly method: 'put';
  readonly params?: { companyId: string | number; brandId: string | number; brandCredentialId: string | number };
};

type APIRoute_customer_brands_currencies_update = {
  readonly name: 'api.customer.brands.currencies.update';
  readonly method: 'post';
  readonly params?: { companyId: string | number; brandId: string | number };
};

type APIRoute_customer_brands_games_export = {
  readonly name: 'api.customer.brands.games.export';
  readonly method: 'get';
  readonly params?: { companyId: string | number; brandId: string | number };
};

type APIRoute_customer_brands_games_list = {
  readonly name: 'api.customer.brands.games.list';
  readonly method: 'get';
  readonly params?: { companyId: string | number; brandId: string | number };
};

type APIRoute_customer_brands_list = {
  readonly name: 'api.customer.brands.list';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_brands_provider_credentials_index = {
  readonly name: 'api.customer.brands.provider_credentials.index';
  readonly method: 'get';
  readonly params?: { companyId: string | number; brandId: string | number };
};

type APIRoute_customer_brands_providers_export = {
  readonly name: 'api.customer.brands.providers.export';
  readonly method: 'get';
  readonly params?: { companyId: string | number; brandId: string | number };
};

type APIRoute_customer_brands_providers_list = {
  readonly name: 'api.customer.brands.providers.list';
  readonly method: 'get';
  readonly params?: { companyId: string | number; brandId: string | number };
};

type APIRoute_customer_brands_public_api_endpoints = {
  readonly name: 'api.customer.brands.public_api.endpoints';
  readonly method: 'get';
  readonly params?: { companyId: string | number; brandId: string | number };
};

type APIRoute_customer_brands_public_api_test = {
  readonly name: 'api.customer.brands.public_api.test';
  readonly method: 'post';
  readonly params?: { companyId: string | number; brandId: string | number };
};

type APIRoute_customer_brands_show = {
  readonly name: 'api.customer.brands.show';
  readonly method: 'get';
  readonly params?: { companyId: string | number; brandId: string | number };
};

type APIRoute_customer_companies = {
  readonly name: 'api.customer.companies';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_customer_currencies_index = {
  readonly name: 'api.customer.currencies.index';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_customer_dashboard_gaming_analytics = {
  readonly name: 'api.customer.dashboard.gaming_analytics';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_dashboard_geo_performance = {
  readonly name: 'api.customer.dashboard.geo_performance';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_dashboard_top_games = {
  readonly name: 'api.customer.dashboard.top_games';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_dashboard_top_providers = {
  readonly name: 'api.customer.dashboard.top_providers';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_game_sessions_show = {
  readonly name: 'api.customer.game_sessions.show';
  readonly method: 'get';
  readonly params?: { companyId: string | number; sessionId: string | number };
};

type APIRoute_customer_invitations_destroy = {
  readonly name: 'api.customer.invitations.destroy';
  readonly method: 'delete';
  readonly params?: { companyId: string | number; companyInvitationId: string | number };
};

type APIRoute_customer_invitations_index = {
  readonly name: 'api.customer.invitations.index';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_invitations_resend = {
  readonly name: 'api.customer.invitations.resend';
  readonly method: 'post';
  readonly params?: { companyId: string | number; companyInvitationId: string | number };
};

type APIRoute_customer_invitations_store = {
  readonly name: 'api.customer.invitations.store';
  readonly method: 'post';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_pending_invitations = {
  readonly name: 'api.customer.pending_invitations';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_customer_permissions = {
  readonly name: 'api.customer.permissions';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_players_game_sessions = {
  readonly name: 'api.customer.players.game_sessions';
  readonly method: 'get';
  readonly params?: { companyId: string | number; playerId: string | number };
};

type APIRoute_customer_players_games = {
  readonly name: 'api.customer.players.games';
  readonly method: 'get';
  readonly params?: { companyId: string | number; playerId: string | number };
};

type APIRoute_customer_players_lifetime_stats = {
  readonly name: 'api.customer.players.lifetime_stats';
  readonly method: 'get';
  readonly params?: { companyId: string | number; playerId: string | number };
};

type APIRoute_customer_players_list = {
  readonly name: 'api.customer.players.list';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_players_show = {
  readonly name: 'api.customer.players.show';
  readonly method: 'get';
  readonly params?: { companyId: string | number; playerId: string | number };
};

type APIRoute_customer_players_transactions = {
  readonly name: 'api.customer.players.transactions';
  readonly method: 'get';
  readonly params?: { companyId: string | number; playerId: string | number };
};

type APIRoute_customer_reports_gambling_summary_export = {
  readonly name: 'api.customer.reports.gambling_summary.export';
  readonly method: 'post';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_reports_gambling_summary_index = {
  readonly name: 'api.customer.reports.gambling_summary.index';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_reports_games_index = {
  readonly name: 'api.customer.reports.games.index';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_reports_games_trend = {
  readonly name: 'api.customer.reports.games.trend';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_reports_players_export = {
  readonly name: 'api.customer.reports.players.export';
  readonly method: 'post';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_reports_players_index = {
  readonly name: 'api.customer.reports.players.index';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_reports_promotions_export = {
  readonly name: 'api.customer.reports.promotions.export';
  readonly method: 'post';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_reports_promotions_index = {
  readonly name: 'api.customer.reports.promotions.index';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_roles_destroy = {
  readonly name: 'api.customer.roles.destroy';
  readonly method: 'delete';
  readonly params?: { companyId: string | number; roleId: string | number };
};

type APIRoute_customer_roles_index = {
  readonly name: 'api.customer.roles.index';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_roles_permissions = {
  readonly name: 'api.customer.roles.permissions';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_roles_show = {
  readonly name: 'api.customer.roles.show';
  readonly method: 'get';
  readonly params?: { companyId: string | number; roleId: string | number };
};

type APIRoute_customer_roles_store = {
  readonly name: 'api.customer.roles.store';
  readonly method: 'post';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_roles_update = {
  readonly name: 'api.customer.roles.update';
  readonly method: 'put';
  readonly params?: { companyId: string | number; roleId: string | number };
};

type APIRoute_customer_roles_users_assign = {
  readonly name: 'api.customer.roles.users.assign';
  readonly method: 'post';
  readonly params?: { companyId: string | number; roleId: string | number };
};

type APIRoute_customer_roles_users_index = {
  readonly name: 'api.customer.roles.users.index';
  readonly method: 'get';
  readonly params?: { companyId: string | number; roleId: string | number };
};

type APIRoute_customer_roles_users_remove = {
  readonly name: 'api.customer.roles.users.remove';
  readonly method: 'delete';
  readonly params?: { companyId: string | number; roleId: string | number; customerId: string | number };
};

type APIRoute_customer_search = {
  readonly name: 'api.customer.search';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_settings_show = {
  readonly name: 'api.customer.settings.show';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_settings_update = {
  readonly name: 'api.customer.settings.update';
  readonly method: 'put';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_transactions_audit_logs = {
  readonly name: 'api.customer.transactions.audit_logs';
  readonly method: 'get';
  readonly params?: { companyId: string | number; transactionId: string | number };
};

type APIRoute_customer_transactions_dashboard = {
  readonly name: 'api.customer.transactions.dashboard';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_transactions_details = {
  readonly name: 'api.customer.transactions.details';
  readonly method: 'get';
  readonly params?: { companyId: string | number; transactionId: string | number };
};

type APIRoute_customer_transactions_index = {
  readonly name: 'api.customer.transactions.index';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_transactions_recent = {
  readonly name: 'api.customer.transactions.recent';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_transactions_reports_generate = {
  readonly name: 'api.customer.transactions.reports.generate';
  readonly method: 'post';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_transactions_retry = {
  readonly name: 'api.customer.transactions.retry';
  readonly method: 'post';
  readonly params?: { companyId: string | number; transactionId: string | number };
};

type APIRoute_customer_transactions_round_details_url = {
  readonly name: 'api.customer.transactions.round_details_url';
  readonly method: 'get';
  readonly params?: { companyId: string | number; transactionId: string | number };
};

type APIRoute_customer_transactions_stats = {
  readonly name: 'api.customer.transactions.stats';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_users_index = {
  readonly name: 'api.customer.users.index';
  readonly method: 'get';
  readonly params?: { companyId: string | number };
};

type APIRoute_customer_users_permissions_update = {
  readonly name: 'api.customer.users.permissions.update';
  readonly method: 'patch';
  readonly params?: { companyId: string | number; customerId: string | number };
};

type APIRoute_customer_users_roles_update = {
  readonly name: 'api.customer.users.roles.update';
  readonly method: 'patch';
  readonly params?: { companyId: string | number; customerId: string | number };
};

type APIRoute_customer_users_show = {
  readonly name: 'api.customer.users.show';
  readonly method: 'get';
  readonly params?: { companyId: string | number; customerId: string | number };
};

type APIRoute_docs_index = {
  readonly name: 'api.docs.index';
  readonly method: 'get';
  readonly params?: { docType: string | number; version: string | number };
};

type APIRoute_docs_section = {
  readonly name: 'api.docs.section';
  readonly method: 'get';
  readonly params?: { docType: string | number; version: string | number; filename: string | number };
};

type APIRoute_docs_versions = {
  readonly name: 'api.docs.versions';
  readonly method: 'get';
  readonly params?: { docType: string | number };
};

type APIRoute_invitations_accept = {
  readonly name: 'api.invitations.accept';
  readonly method: 'post';
  readonly params?: { token: string | number };
};

type APIRoute_invitations_reject = {
  readonly name: 'api.invitations.reject';
  readonly method: 'post';
  readonly params?: { token: string | number };
};

type APIRoute_invitations_show = {
  readonly name: 'api.invitations.show';
  readonly method: 'get';
  readonly params?: { token: string | number };
};

type APIRoute_public_api_documentation = {
  readonly name: 'api.public_api.documentation';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_timezones = {
  readonly name: 'api.timezones';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_translations_all = {
  readonly name: 'api.translations.all';
  readonly method: 'get';
  readonly params?: null;
};

type APIRoute_translations_for_locale = {
  readonly name: 'api.translations.for_locale';
  readonly method: 'get';
  readonly params?: { locale: string | number };
};

type AllRouteConfigs =
  | APIRoute_admin_activityLogs_list
  | APIRoute_admin_api_type_descriptors_list
  | APIRoute_admin_api_types_list
  | APIRoute_admin_brands_activity_log_list
  | APIRoute_admin_brands_callback_audit_index
  | APIRoute_admin_brands_callback_tests_documentation
  | APIRoute_admin_brands_callback_tests_index
  | APIRoute_admin_brands_callback_tests_results_show
  | APIRoute_admin_brands_callback_tests_run
  | APIRoute_admin_brands_callback_tests_runs_index
  | APIRoute_admin_brands_callback_urls_create
  | APIRoute_admin_brands_callback_urls_delete
  | APIRoute_admin_brands_callback_urls_list
  | APIRoute_admin_brands_callback_urls_secrets_activate
  | APIRoute_admin_brands_callback_urls_secrets_delete
  | APIRoute_admin_brands_callback_urls_secrets_generate
  | APIRoute_admin_brands_callback_urls_update
  | APIRoute_admin_brands_countries_currencies
  | APIRoute_admin_brands_create
  | APIRoute_admin_brands_credentials_delete
  | APIRoute_admin_brands_credentials_generate
  | APIRoute_admin_brands_credentials_list
  | APIRoute_admin_brands_credentials_update
  | APIRoute_admin_brands_currencies_update
  | APIRoute_admin_brands_delete
  | APIRoute_admin_brands_games_export
  | APIRoute_admin_brands_games_list
  | APIRoute_admin_brands_games_toggle
  | APIRoute_admin_brands_list
  | APIRoute_admin_brands_preview_move_impact
  | APIRoute_admin_brands_provider_credentials_bulk_delete
  | APIRoute_admin_brands_provider_credentials_debug
  | APIRoute_admin_brands_provider_credentials_defaults
  | APIRoute_admin_brands_provider_credentials_delete
  | APIRoute_admin_brands_provider_credentials_effective
  | APIRoute_admin_brands_provider_credentials_generate_idn_live_operator_ids
  | APIRoute_admin_brands_provider_credentials_incomplete
  | APIRoute_admin_brands_provider_credentials_index
  | APIRoute_admin_brands_provider_credentials_overrides
  | APIRoute_admin_brands_provider_credentials_parse_csv
  | APIRoute_admin_brands_provider_credentials_save
  | APIRoute_admin_brands_provider_credentials_schema
  | APIRoute_admin_brands_providers_export
  | APIRoute_admin_brands_providers_list
  | APIRoute_admin_brands_providers_update
  | APIRoute_admin_brands_show
  | APIRoute_admin_brands_update
  | APIRoute_admin_callback_api_documentation
  | APIRoute_admin_companies_activity_logs
  | APIRoute_admin_companies_api_types_preview_impact
  | APIRoute_admin_companies_api_types_show
  | APIRoute_admin_companies_api_types_update
  | APIRoute_admin_companies_assignable_roles
  | APIRoute_admin_companies_available_customers
  | APIRoute_admin_companies_create
  | APIRoute_admin_companies_customer_permissions
  | APIRoute_admin_companies_customers_attach
  | APIRoute_admin_companies_customers_detach
  | APIRoute_admin_companies_customers_list
  | APIRoute_admin_companies_customers_update
  | APIRoute_admin_companies_delete
  | APIRoute_admin_companies_invitations_destroy
  | APIRoute_admin_companies_invitations_index
  | APIRoute_admin_companies_invitations_resend
  | APIRoute_admin_companies_invitations_store
  | APIRoute_admin_companies_list
  | APIRoute_admin_companies_roles_destroy
  | APIRoute_admin_companies_roles_store
  | APIRoute_admin_companies_roles_update
  | APIRoute_admin_companies_show
  | APIRoute_admin_companies_update
  | APIRoute_admin_companies_users_permissions_update
  | APIRoute_admin_companies_users_roles_update
  | APIRoute_admin_companies_users_show
  | APIRoute_admin_countries_index
  | APIRoute_admin_currencies_index
  | APIRoute_admin_customers_users_destroy
  | APIRoute_admin_customers_users_index
  | APIRoute_admin_customers_users_show
  | APIRoute_admin_customers_users_store
  | APIRoute_admin_customers_users_update
  | APIRoute_admin_dashboard_gaming_analytics
  | APIRoute_admin_dashboard_geo_performance
  | APIRoute_admin_dashboard_top_games
  | APIRoute_admin_dashboard_top_providers
  | APIRoute_admin_discount_programs_delete
  | APIRoute_admin_discount_programs_index
  | APIRoute_admin_discount_programs_preview
  | APIRoute_admin_discount_programs_show
  | APIRoute_admin_discount_programs_store
  | APIRoute_admin_discount_programs_update
  | APIRoute_admin_docs_index
  | APIRoute_admin_docs_section
  | APIRoute_admin_docs_versions
  | APIRoute_admin_employees_roles_assign_employees
  | APIRoute_admin_employees_roles_destroy
  | APIRoute_admin_employees_roles_index
  | APIRoute_admin_employees_roles_permissions
  | APIRoute_admin_employees_roles_remove_employee
  | APIRoute_admin_employees_roles_show
  | APIRoute_admin_employees_roles_store
  | APIRoute_admin_employees_roles_update
  | APIRoute_admin_employees_users_destroy
  | APIRoute_admin_employees_users_index
  | APIRoute_admin_employees_users_permissions_update
  | APIRoute_admin_employees_users_roles_update
  | APIRoute_admin_employees_users_show
  | APIRoute_admin_employees_users_store
  | APIRoute_admin_employees_users_update
  | APIRoute_admin_exchangeRates_list
  | APIRoute_admin_game_sessions_show
  | APIRoute_admin_games_create
  | APIRoute_admin_games_delete
  | APIRoute_admin_games_export
  | APIRoute_admin_games_list
  | APIRoute_admin_games_show
  | APIRoute_admin_games_update
  | APIRoute_admin_invoices_aging
  | APIRoute_admin_invoices_commissions_alerts
  | APIRoute_admin_invoices_commissions_list
  | APIRoute_admin_invoices_commissions_update
  | APIRoute_admin_invoices_discounts_create
  | APIRoute_admin_invoices_discounts_delete
  | APIRoute_admin_invoices_discounts_update
  | APIRoute_admin_invoices_export
  | APIRoute_admin_invoices_index
  | APIRoute_admin_invoices_lock_update
  | APIRoute_admin_invoices_payment_update
  | APIRoute_admin_invoices_preview
  | APIRoute_admin_invoices_show
  | APIRoute_admin_invoices_structure
  | APIRoute_admin_invoices_template_update
  | APIRoute_admin_launcher_domains_create
  | APIRoute_admin_launcher_domains_delete
  | APIRoute_admin_launcher_domains_index
  | APIRoute_admin_launcher_domains_retry
  | APIRoute_admin_launcher_domains_status
  | APIRoute_admin_launcher_domains_toggle_status
  | APIRoute_admin_launcher_domains_update
  | APIRoute_admin_mainProviders_list
  | APIRoute_admin_mainProviders_show
  | APIRoute_admin_mainProviders_update
  | APIRoute_admin_organizations_create
  | APIRoute_admin_organizations_delete
  | APIRoute_admin_organizations_index
  | APIRoute_admin_organizations_show
  | APIRoute_admin_organizations_update
  | APIRoute_admin_players_game_sessions
  | APIRoute_admin_players_games
  | APIRoute_admin_players_lifetime_stats
  | APIRoute_admin_players_list
  | APIRoute_admin_players_mark_as_demo
  | APIRoute_admin_players_show
  | APIRoute_admin_providerCredentials_types
  | APIRoute_admin_providers_brands
  | APIRoute_admin_providers_export
  | APIRoute_admin_providers_list
  | APIRoute_admin_providers_show
  | APIRoute_admin_providers_update
  | APIRoute_admin_public_api_documentation
  | APIRoute_admin_public_api_endpoints
  | APIRoute_admin_public_api_test
  | APIRoute_admin_reports_gambling_summary_export
  | APIRoute_admin_reports_gambling_summary_index
  | APIRoute_admin_reports_games_index
  | APIRoute_admin_reports_games_trend
  | APIRoute_admin_reports_players_export
  | APIRoute_admin_reports_players_index
  | APIRoute_admin_reports_promotions_export
  | APIRoute_admin_reports_promotions_index
  | APIRoute_admin_search
  | APIRoute_admin_transactions_audit_logs
  | APIRoute_admin_transactions_cancel
  | APIRoute_admin_transactions_dashboard
  | APIRoute_admin_transactions_details
  | APIRoute_admin_transactions_index
  | APIRoute_admin_transactions_player
  | APIRoute_admin_transactions_recent
  | APIRoute_admin_transactions_reports_generate
  | APIRoute_admin_transactions_retry
  | APIRoute_admin_transactions_round_details_url
  | APIRoute_admin_transactions_stats
  | APIRoute_admin_translation_overrides_all_language_codes
  | APIRoute_admin_translation_overrides_available_keys
  | APIRoute_admin_translation_overrides_available_locales
  | APIRoute_admin_translation_overrides_create_locale
  | APIRoute_admin_translation_overrides_delete
  | APIRoute_admin_translation_overrides_delete_locale
  | APIRoute_admin_translation_overrides_disable_locale
  | APIRoute_admin_translation_overrides_enable_locale
  | APIRoute_admin_translation_overrides_list
  | APIRoute_admin_translation_overrides_upsert
  | APIRoute_auth_check_sensitive
  | APIRoute_auth_confirm_sensitive
  | APIRoute_auth_login
  | APIRoute_auth_logout
  | APIRoute_auth_refresh
  | APIRoute_auth_two_fa_backup_codes_generate
  | APIRoute_auth_two_fa_backup_codes_index
  | APIRoute_auth_two_fa_devices_create
  | APIRoute_auth_two_fa_devices_delete
  | APIRoute_auth_two_fa_devices_index
  | APIRoute_auth_two_fa_devices_verify
  | APIRoute_auth_two_fa_verify
  | APIRoute_auth_user_activity_logs
  | APIRoute_auth_user_email_update
  | APIRoute_auth_user_email_verify
  | APIRoute_auth_user_locale_update
  | APIRoute_auth_user_login_logs
  | APIRoute_auth_user_password_update
  | APIRoute_auth_user_sessions_index
  | APIRoute_auth_user_sessions_revoke
  | APIRoute_auth_user_show
  | APIRoute_auth_user_timezone_update
  | APIRoute_callback_api_documentation
  | APIRoute_customer_activity_log_list
  | APIRoute_customer_api_type_descriptors_list
  | APIRoute_customer_assignable_roles
  | APIRoute_customer_brands_activity_log_list
  | APIRoute_customer_brands_callback_audit_index
  | APIRoute_customer_brands_callback_tests_documentation
  | APIRoute_customer_brands_callback_tests_index
  | APIRoute_customer_brands_callback_tests_results_show
  | APIRoute_customer_brands_callback_tests_run
  | APIRoute_customer_brands_callback_tests_runs_index
  | APIRoute_customer_brands_callback_urls_create
  | APIRoute_customer_brands_callback_urls_delete
  | APIRoute_customer_brands_callback_urls_list
  | APIRoute_customer_brands_callback_urls_secrets_activate
  | APIRoute_customer_brands_callback_urls_secrets_delete
  | APIRoute_customer_brands_callback_urls_secrets_generate
  | APIRoute_customer_brands_callback_urls_update
  | APIRoute_customer_brands_countries_currencies
  | APIRoute_customer_brands_credentials_delete
  | APIRoute_customer_brands_credentials_generate
  | APIRoute_customer_brands_credentials_list
  | APIRoute_customer_brands_credentials_update
  | APIRoute_customer_brands_currencies_update
  | APIRoute_customer_brands_games_export
  | APIRoute_customer_brands_games_list
  | APIRoute_customer_brands_list
  | APIRoute_customer_brands_provider_credentials_index
  | APIRoute_customer_brands_providers_export
  | APIRoute_customer_brands_providers_list
  | APIRoute_customer_brands_public_api_endpoints
  | APIRoute_customer_brands_public_api_test
  | APIRoute_customer_brands_show
  | APIRoute_customer_companies
  | APIRoute_customer_currencies_index
  | APIRoute_customer_dashboard_gaming_analytics
  | APIRoute_customer_dashboard_geo_performance
  | APIRoute_customer_dashboard_top_games
  | APIRoute_customer_dashboard_top_providers
  | APIRoute_customer_game_sessions_show
  | APIRoute_customer_invitations_destroy
  | APIRoute_customer_invitations_index
  | APIRoute_customer_invitations_resend
  | APIRoute_customer_invitations_store
  | APIRoute_customer_pending_invitations
  | APIRoute_customer_permissions
  | APIRoute_customer_players_game_sessions
  | APIRoute_customer_players_games
  | APIRoute_customer_players_lifetime_stats
  | APIRoute_customer_players_list
  | APIRoute_customer_players_show
  | APIRoute_customer_players_transactions
  | APIRoute_customer_reports_gambling_summary_export
  | APIRoute_customer_reports_gambling_summary_index
  | APIRoute_customer_reports_games_index
  | APIRoute_customer_reports_games_trend
  | APIRoute_customer_reports_players_export
  | APIRoute_customer_reports_players_index
  | APIRoute_customer_reports_promotions_export
  | APIRoute_customer_reports_promotions_index
  | APIRoute_customer_roles_destroy
  | APIRoute_customer_roles_index
  | APIRoute_customer_roles_permissions
  | APIRoute_customer_roles_show
  | APIRoute_customer_roles_store
  | APIRoute_customer_roles_update
  | APIRoute_customer_roles_users_assign
  | APIRoute_customer_roles_users_index
  | APIRoute_customer_roles_users_remove
  | APIRoute_customer_search
  | APIRoute_customer_settings_show
  | APIRoute_customer_settings_update
  | APIRoute_customer_transactions_audit_logs
  | APIRoute_customer_transactions_dashboard
  | APIRoute_customer_transactions_details
  | APIRoute_customer_transactions_index
  | APIRoute_customer_transactions_recent
  | APIRoute_customer_transactions_reports_generate
  | APIRoute_customer_transactions_retry
  | APIRoute_customer_transactions_round_details_url
  | APIRoute_customer_transactions_stats
  | APIRoute_customer_users_index
  | APIRoute_customer_users_permissions_update
  | APIRoute_customer_users_roles_update
  | APIRoute_customer_users_show
  | APIRoute_docs_index
  | APIRoute_docs_section
  | APIRoute_docs_versions
  | APIRoute_invitations_accept
  | APIRoute_invitations_reject
  | APIRoute_invitations_show
  | APIRoute_public_api_documentation
  | APIRoute_timezones
  | APIRoute_translations_all
  | APIRoute_translations_for_locale;

export const API_ROUTES = {
  admin: {
    activityLogs: {
      list: {
        name: 'api.admin.activityLogs.list',
        method: 'get',
      },
    },
    api_type_descriptors: {
      list: {
        name: 'api.admin.api_type_descriptors.list',
        method: 'get',
      },
    },
    api_types: {
      list: {
        name: 'api.admin.api_types.list',
        method: 'get',
      },
    },
    brands: {
      activity_log: {
        list: {
          name: 'api.admin.brands.activity_log.list',
          method: 'get',
        },
      },
      callback_audit: {
        index: {
          name: 'api.admin.brands.callback_audit.index',
          method: 'get',
        },
      },
      callback_tests: {
        documentation: {
          name: 'api.admin.brands.callback_tests.documentation',
          method: 'get',
        },
        index: {
          name: 'api.admin.brands.callback_tests.index',
          method: 'get',
        },
        results: {
          show: {
            name: 'api.admin.brands.callback_tests.results.show',
            method: 'get',
          },
        },
        run: {
          name: 'api.admin.brands.callback_tests.run',
          method: 'post',
        },
        runs: {
          index: {
            name: 'api.admin.brands.callback_tests.runs.index',
            method: 'get',
          },
        },
      },
      callback_urls: {
        create: {
          name: 'api.admin.brands.callback_urls.create',
          method: 'post',
        },
        delete: {
          name: 'api.admin.brands.callback_urls.delete',
          method: 'delete',
        },
        list: {
          name: 'api.admin.brands.callback_urls.list',
          method: 'get',
        },
        secrets: {
          activate: {
            name: 'api.admin.brands.callback_urls.secrets.activate',
            method: 'post',
          },
          delete: {
            name: 'api.admin.brands.callback_urls.secrets.delete',
            method: 'delete',
          },
          generate: {
            name: 'api.admin.brands.callback_urls.secrets.generate',
            method: 'post',
          },
        },
        update: {
          name: 'api.admin.brands.callback_urls.update',
          method: 'put',
        },
      },
      countries_currencies: {
        name: 'api.admin.brands.countries_currencies',
        method: 'get',
      },
      create: {
        name: 'api.admin.brands.create',
        method: 'post',
      },
      credentials: {
        delete: {
          name: 'api.admin.brands.credentials.delete',
          method: 'delete',
        },
        generate: {
          name: 'api.admin.brands.credentials.generate',
          method: 'post',
        },
        list: {
          name: 'api.admin.brands.credentials.list',
          method: 'get',
        },
        update: {
          name: 'api.admin.brands.credentials.update',
          method: 'put',
        },
      },
      currencies: {
        update: {
          name: 'api.admin.brands.currencies.update',
          method: 'post',
        },
      },
      delete: {
        name: 'api.admin.brands.delete',
        method: 'delete',
      },
      games: {
        export: {
          name: 'api.admin.brands.games.export',
          method: 'get',
        },
        list: {
          name: 'api.admin.brands.games.list',
          method: 'get',
        },
        toggle: {
          name: 'api.admin.brands.games.toggle',
          method: 'post',
        },
      },
      list: {
        name: 'api.admin.brands.list',
        method: 'get',
      },
      preview_move_impact: {
        name: 'api.admin.brands.preview_move_impact',
        method: 'post',
      },
      provider_credentials: {
        bulk_delete: {
          name: 'api.admin.brands.provider_credentials.bulk_delete',
          method: 'post',
        },
        debug: {
          name: 'api.admin.brands.provider_credentials.debug',
          method: 'get',
        },
        defaults: {
          name: 'api.admin.brands.provider_credentials.defaults',
          method: 'get',
        },
        delete: {
          name: 'api.admin.brands.provider_credentials.delete',
          method: 'delete',
        },
        effective: {
          name: 'api.admin.brands.provider_credentials.effective',
          method: 'get',
        },
        generate_idn_live_operator_ids: {
          name: 'api.admin.brands.provider_credentials.generate_idn_live_operator_ids',
          method: 'post',
        },
        incomplete: {
          name: 'api.admin.brands.provider_credentials.incomplete',
          method: 'get',
        },
        index: {
          name: 'api.admin.brands.provider_credentials.index',
          method: 'get',
        },
        overrides: {
          name: 'api.admin.brands.provider_credentials.overrides',
          method: 'get',
        },
        parse_csv: {
          name: 'api.admin.brands.provider_credentials.parse_csv',
          method: 'post',
        },
        save: {
          name: 'api.admin.brands.provider_credentials.save',
          method: 'post',
        },
        schema: {
          name: 'api.admin.brands.provider_credentials.schema',
          method: 'get',
        },
      },
      providers: {
        export: {
          name: 'api.admin.brands.providers.export',
          method: 'get',
        },
        list: {
          name: 'api.admin.brands.providers.list',
          method: 'get',
        },
        update: {
          name: 'api.admin.brands.providers.update',
          method: 'post',
        },
      },
      show: {
        name: 'api.admin.brands.show',
        method: 'get',
      },
      update: {
        name: 'api.admin.brands.update',
        method: 'put',
      },
    },
    callback_api: {
      documentation: {
        name: 'api.admin.callback_api.documentation',
        method: 'get',
      },
    },
    companies: {
      activity_logs: {
        name: 'api.admin.companies.activity_logs',
        method: 'get',
      },
      api_types: {
        preview_impact: {
          name: 'api.admin.companies.api_types.preview_impact',
          method: 'post',
        },
        show: {
          name: 'api.admin.companies.api_types.show',
          method: 'get',
        },
        update: {
          name: 'api.admin.companies.api_types.update',
          method: 'put',
        },
      },
      assignable_roles: {
        name: 'api.admin.companies.assignable_roles',
        method: 'get',
      },
      available_customers: {
        name: 'api.admin.companies.available_customers',
        method: 'get',
      },
      create: {
        name: 'api.admin.companies.create',
        method: 'post',
      },
      customer_permissions: {
        name: 'api.admin.companies.customer_permissions',
        method: 'get',
      },
      customers: {
        attach: {
          name: 'api.admin.companies.customers.attach',
          method: 'post',
        },
        detach: {
          name: 'api.admin.companies.customers.detach',
          method: 'delete',
        },
        list: {
          name: 'api.admin.companies.customers.list',
          method: 'get',
        },
        update: {
          name: 'api.admin.companies.customers.update',
          method: 'patch',
        },
      },
      delete: {
        name: 'api.admin.companies.delete',
        method: 'delete',
      },
      invitations: {
        destroy: {
          name: 'api.admin.companies.invitations.destroy',
          method: 'delete',
        },
        index: {
          name: 'api.admin.companies.invitations.index',
          method: 'get',
        },
        resend: {
          name: 'api.admin.companies.invitations.resend',
          method: 'post',
        },
        store: {
          name: 'api.admin.companies.invitations.store',
          method: 'post',
        },
      },
      list: {
        name: 'api.admin.companies.list',
        method: 'get',
      },
      roles: {
        destroy: {
          name: 'api.admin.companies.roles.destroy',
          method: 'delete',
        },
        store: {
          name: 'api.admin.companies.roles.store',
          method: 'post',
        },
        update: {
          name: 'api.admin.companies.roles.update',
          method: 'put',
        },
      },
      show: {
        name: 'api.admin.companies.show',
        method: 'get',
      },
      update: {
        name: 'api.admin.companies.update',
        method: 'put',
      },
      users: {
        permissions: {
          update: {
            name: 'api.admin.companies.users.permissions.update',
            method: 'patch',
          },
        },
        roles: {
          update: {
            name: 'api.admin.companies.users.roles.update',
            method: 'patch',
          },
        },
        show: {
          name: 'api.admin.companies.users.show',
          method: 'get',
        },
      },
    },
    countries: {
      index: {
        name: 'api.admin.countries.index',
        method: 'get',
      },
    },
    currencies: {
      index: {
        name: 'api.admin.currencies.index',
        method: 'get',
      },
    },
    customers: {
      users: {
        destroy: {
          name: 'api.admin.customers.users.destroy',
          method: 'delete',
        },
        index: {
          name: 'api.admin.customers.users.index',
          method: 'get',
        },
        show: {
          name: 'api.admin.customers.users.show',
          method: 'get',
        },
        store: {
          name: 'api.admin.customers.users.store',
          method: 'post',
        },
        update: {
          name: 'api.admin.customers.users.update',
          method: 'put',
        },
      },
    },
    dashboard: {
      gaming_analytics: {
        name: 'api.admin.dashboard.gaming_analytics',
        method: 'get',
      },
      geo_performance: {
        name: 'api.admin.dashboard.geo_performance',
        method: 'get',
      },
      top_games: {
        name: 'api.admin.dashboard.top_games',
        method: 'get',
      },
      top_providers: {
        name: 'api.admin.dashboard.top_providers',
        method: 'get',
      },
    },
    discount_programs: {
      delete: {
        name: 'api.admin.discount_programs.delete',
        method: 'delete',
      },
      index: {
        name: 'api.admin.discount_programs.index',
        method: 'get',
      },
      preview: {
        name: 'api.admin.discount_programs.preview',
        method: 'post',
      },
      show: {
        name: 'api.admin.discount_programs.show',
        method: 'get',
      },
      store: {
        name: 'api.admin.discount_programs.store',
        method: 'post',
      },
      update: {
        name: 'api.admin.discount_programs.update',
        method: 'put',
      },
    },
    docs: {
      index: {
        name: 'api.admin.docs.index',
        method: 'get',
      },
      section: {
        name: 'api.admin.docs.section',
        method: 'get',
      },
      versions: {
        name: 'api.admin.docs.versions',
        method: 'get',
      },
    },
    employees: {
      roles: {
        assign_employees: {
          name: 'api.admin.employees.roles.assign_employees',
          method: 'post',
        },
        destroy: {
          name: 'api.admin.employees.roles.destroy',
          method: 'delete',
        },
        index: {
          name: 'api.admin.employees.roles.index',
          method: 'get',
        },
        permissions: {
          name: 'api.admin.employees.roles.permissions',
          method: 'get',
        },
        remove_employee: {
          name: 'api.admin.employees.roles.remove_employee',
          method: 'delete',
        },
        show: {
          name: 'api.admin.employees.roles.show',
          method: 'get',
        },
        store: {
          name: 'api.admin.employees.roles.store',
          method: 'post',
        },
        update: {
          name: 'api.admin.employees.roles.update',
          method: 'put',
        },
      },
      users: {
        destroy: {
          name: 'api.admin.employees.users.destroy',
          method: 'delete',
        },
        index: {
          name: 'api.admin.employees.users.index',
          method: 'get',
        },
        permissions: {
          update: {
            name: 'api.admin.employees.users.permissions.update',
            method: 'patch',
          },
        },
        roles: {
          update: {
            name: 'api.admin.employees.users.roles.update',
            method: 'patch',
          },
        },
        show: {
          name: 'api.admin.employees.users.show',
          method: 'get',
        },
        store: {
          name: 'api.admin.employees.users.store',
          method: 'post',
        },
        update: {
          name: 'api.admin.employees.users.update',
          method: 'put',
        },
      },
    },
    exchangeRates: {
      list: {
        name: 'api.admin.exchangeRates.list',
        method: 'get',
      },
    },
    game_sessions: {
      show: {
        name: 'api.admin.game_sessions.show',
        method: 'get',
      },
    },
    games: {
      create: {
        name: 'api.admin.games.create',
        method: 'post',
      },
      delete: {
        name: 'api.admin.games.delete',
        method: 'delete',
      },
      export: {
        name: 'api.admin.games.export',
        method: 'get',
      },
      list: {
        name: 'api.admin.games.list',
        method: 'get',
      },
      show: {
        name: 'api.admin.games.show',
        method: 'get',
      },
      update: {
        name: 'api.admin.games.update',
        method: 'put',
      },
    },
    invoices: {
      aging: {
        name: 'api.admin.invoices.aging',
        method: 'get',
      },
      commissions: {
        alerts: {
          name: 'api.admin.invoices.commissions.alerts',
          method: 'get',
        },
        list: {
          name: 'api.admin.invoices.commissions.list',
          method: 'get',
        },
        update: {
          name: 'api.admin.invoices.commissions.update',
          method: 'put',
        },
      },
      discounts: {
        create: {
          name: 'api.admin.invoices.discounts.create',
          method: 'post',
        },
        delete: {
          name: 'api.admin.invoices.discounts.delete',
          method: 'delete',
        },
        update: {
          name: 'api.admin.invoices.discounts.update',
          method: 'put',
        },
      },
      export: {
        name: 'api.admin.invoices.export',
        method: 'get',
      },
      index: {
        name: 'api.admin.invoices.index',
        method: 'get',
      },
      lock: {
        update: {
          name: 'api.admin.invoices.lock.update',
          method: 'patch',
        },
      },
      payment: {
        update: {
          name: 'api.admin.invoices.payment.update',
          method: 'patch',
        },
      },
      preview: {
        name: 'api.admin.invoices.preview',
        method: 'get',
      },
      show: {
        name: 'api.admin.invoices.show',
        method: 'get',
      },
      structure: {
        name: 'api.admin.invoices.structure',
        method: 'get',
      },
      template: {
        update: {
          name: 'api.admin.invoices.template.update',
          method: 'patch',
        },
      },
    },
    launcher_domains: {
      create: {
        name: 'api.admin.launcher_domains.create',
        method: 'post',
      },
      delete: {
        name: 'api.admin.launcher_domains.delete',
        method: 'delete',
      },
      index: {
        name: 'api.admin.launcher_domains.index',
        method: 'get',
      },
      retry: {
        name: 'api.admin.launcher_domains.retry',
        method: 'post',
      },
      status: {
        name: 'api.admin.launcher_domains.status',
        method: 'get',
      },
      toggle_status: {
        name: 'api.admin.launcher_domains.toggle_status',
        method: 'patch',
      },
      update: {
        name: 'api.admin.launcher_domains.update',
        method: 'put',
      },
    },
    mainProviders: {
      list: {
        name: 'api.admin.mainProviders.list',
        method: 'get',
      },
      show: {
        name: 'api.admin.mainProviders.show',
        method: 'get',
      },
      update: {
        name: 'api.admin.mainProviders.update',
        method: 'put',
      },
    },
    organizations: {
      create: {
        name: 'api.admin.organizations.create',
        method: 'post',
      },
      delete: {
        name: 'api.admin.organizations.delete',
        method: 'delete',
      },
      index: {
        name: 'api.admin.organizations.index',
        method: 'get',
      },
      show: {
        name: 'api.admin.organizations.show',
        method: 'get',
      },
      update: {
        name: 'api.admin.organizations.update',
        method: 'put',
      },
    },
    players: {
      game_sessions: {
        name: 'api.admin.players.game_sessions',
        method: 'get',
      },
      games: {
        name: 'api.admin.players.games',
        method: 'get',
      },
      lifetime_stats: {
        name: 'api.admin.players.lifetime_stats',
        method: 'get',
      },
      list: {
        name: 'api.admin.players.list',
        method: 'get',
      },
      mark_as_demo: {
        name: 'api.admin.players.mark_as_demo',
        method: 'post',
      },
      show: {
        name: 'api.admin.players.show',
        method: 'get',
      },
    },
    providerCredentials: {
      types: {
        name: 'api.admin.providerCredentials.types',
        method: 'get',
      },
    },
    providers: {
      brands: {
        name: 'api.admin.providers.brands',
        method: 'get',
      },
      export: {
        name: 'api.admin.providers.export',
        method: 'get',
      },
      list: {
        name: 'api.admin.providers.list',
        method: 'get',
      },
      show: {
        name: 'api.admin.providers.show',
        method: 'get',
      },
      update: {
        name: 'api.admin.providers.update',
        method: 'put',
      },
    },
    public_api: {
      documentation: {
        name: 'api.admin.public_api.documentation',
        method: 'get',
      },
      endpoints: {
        name: 'api.admin.public_api.endpoints',
        method: 'get',
      },
      test: {
        name: 'api.admin.public_api.test',
        method: 'post',
      },
    },
    reports: {
      gambling_summary: {
        export: {
          name: 'api.admin.reports.gambling_summary.export',
          method: 'post',
        },
        index: {
          name: 'api.admin.reports.gambling_summary.index',
          method: 'get',
        },
      },
      games: {
        index: {
          name: 'api.admin.reports.games.index',
          method: 'get',
        },
        trend: {
          name: 'api.admin.reports.games.trend',
          method: 'get',
        },
      },
      players: {
        export: {
          name: 'api.admin.reports.players.export',
          method: 'post',
        },
        index: {
          name: 'api.admin.reports.players.index',
          method: 'get',
        },
      },
      promotions: {
        export: {
          name: 'api.admin.reports.promotions.export',
          method: 'post',
        },
        index: {
          name: 'api.admin.reports.promotions.index',
          method: 'get',
        },
      },
    },
    search: {
      name: 'api.admin.search',
      method: 'get',
    },
    transactions: {
      audit_logs: {
        name: 'api.admin.transactions.audit_logs',
        method: 'get',
      },
      cancel: {
        name: 'api.admin.transactions.cancel',
        method: 'post',
      },
      dashboard: {
        name: 'api.admin.transactions.dashboard',
        method: 'get',
      },
      details: {
        name: 'api.admin.transactions.details',
        method: 'get',
      },
      index: {
        name: 'api.admin.transactions.index',
        method: 'get',
      },
      player: {
        name: 'api.admin.transactions.player',
        method: 'get',
      },
      recent: {
        name: 'api.admin.transactions.recent',
        method: 'get',
      },
      reports: {
        generate: {
          name: 'api.admin.transactions.reports.generate',
          method: 'post',
        },
      },
      retry: {
        name: 'api.admin.transactions.retry',
        method: 'post',
      },
      round_details_url: {
        name: 'api.admin.transactions.round_details_url',
        method: 'get',
      },
      stats: {
        name: 'api.admin.transactions.stats',
        method: 'get',
      },
    },
    translation_overrides: {
      all_language_codes: {
        name: 'api.admin.translation_overrides.all_language_codes',
        method: 'get',
      },
      available_keys: {
        name: 'api.admin.translation_overrides.available_keys',
        method: 'get',
      },
      available_locales: {
        name: 'api.admin.translation_overrides.available_locales',
        method: 'get',
      },
      create_locale: {
        name: 'api.admin.translation_overrides.create_locale',
        method: 'post',
      },
      delete: {
        name: 'api.admin.translation_overrides.delete',
        method: 'delete',
      },
      delete_locale: {
        name: 'api.admin.translation_overrides.delete_locale',
        method: 'delete',
      },
      disable_locale: {
        name: 'api.admin.translation_overrides.disable_locale',
        method: 'post',
      },
      enable_locale: {
        name: 'api.admin.translation_overrides.enable_locale',
        method: 'post',
      },
      list: {
        name: 'api.admin.translation_overrides.list',
        method: 'get',
      },
      upsert: {
        name: 'api.admin.translation_overrides.upsert',
        method: 'post',
      },
    },
  },
  auth: {
    check: {
      sensitive: {
        name: 'api.auth.check.sensitive',
        method: 'get',
      },
    },
    confirm: {
      sensitive: {
        name: 'api.auth.confirm.sensitive',
        method: 'post',
      },
    },
    login: {
      name: 'api.auth.login',
      method: 'post',
    },
    logout: {
      name: 'api.auth.logout',
      method: 'post',
    },
    refresh: {
      name: 'api.auth.refresh',
      method: 'post',
    },
    two_fa: {
      backup_codes: {
        generate: {
          name: 'api.auth.two_fa.backup_codes.generate',
          method: 'post',
        },
        index: {
          name: 'api.auth.two_fa.backup_codes.index',
          method: 'get',
        },
      },
      devices: {
        create: {
          name: 'api.auth.two_fa.devices.create',
          method: 'post',
        },
        delete: {
          name: 'api.auth.two_fa.devices.delete',
          method: 'delete',
        },
        index: {
          name: 'api.auth.two_fa.devices.index',
          method: 'get',
        },
        verify: {
          name: 'api.auth.two_fa.devices.verify',
          method: 'post',
        },
      },
      verify: {
        name: 'api.auth.two_fa.verify',
        method: 'post',
      },
    },
    user: {
      activity_logs: {
        name: 'api.auth.user.activity_logs',
        method: 'get',
      },
      email: {
        update: {
          name: 'api.auth.user.email.update',
          method: 'patch',
        },
        verify: {
          name: 'api.auth.user.email.verify',
          method: 'post',
        },
      },
      locale: {
        update: {
          name: 'api.auth.user.locale.update',
          method: 'patch',
        },
      },
      login_logs: {
        name: 'api.auth.user.login_logs',
        method: 'get',
      },
      password: {
        update: {
          name: 'api.auth.user.password.update',
          method: 'patch',
        },
      },
      sessions: {
        index: {
          name: 'api.auth.user.sessions.index',
          method: 'get',
        },
        revoke: {
          name: 'api.auth.user.sessions.revoke',
          method: 'delete',
        },
      },
      show: {
        name: 'api.auth.user.show',
        method: 'get',
      },
      timezone: {
        update: {
          name: 'api.auth.user.timezone.update',
          method: 'patch',
        },
      },
    },
  },
  callback_api: {
    documentation: {
      name: 'api.callback_api.documentation',
      method: 'get',
    },
  },
  customer: {
    activity_log: {
      list: {
        name: 'api.customer.activity_log.list',
        method: 'get',
      },
    },
    api_type_descriptors: {
      list: {
        name: 'api.customer.api_type_descriptors.list',
        method: 'get',
      },
    },
    assignable_roles: {
      name: 'api.customer.assignable_roles',
      method: 'get',
    },
    brands: {
      activity_log: {
        list: {
          name: 'api.customer.brands.activity_log.list',
          method: 'get',
        },
      },
      callback_audit: {
        index: {
          name: 'api.customer.brands.callback_audit.index',
          method: 'get',
        },
      },
      callback_tests: {
        documentation: {
          name: 'api.customer.brands.callback_tests.documentation',
          method: 'get',
        },
        index: {
          name: 'api.customer.brands.callback_tests.index',
          method: 'get',
        },
        results: {
          show: {
            name: 'api.customer.brands.callback_tests.results.show',
            method: 'get',
          },
        },
        run: {
          name: 'api.customer.brands.callback_tests.run',
          method: 'post',
        },
        runs: {
          index: {
            name: 'api.customer.brands.callback_tests.runs.index',
            method: 'get',
          },
        },
      },
      callback_urls: {
        create: {
          name: 'api.customer.brands.callback_urls.create',
          method: 'post',
        },
        delete: {
          name: 'api.customer.brands.callback_urls.delete',
          method: 'delete',
        },
        list: {
          name: 'api.customer.brands.callback_urls.list',
          method: 'get',
        },
        secrets: {
          activate: {
            name: 'api.customer.brands.callback_urls.secrets.activate',
            method: 'post',
          },
          delete: {
            name: 'api.customer.brands.callback_urls.secrets.delete',
            method: 'delete',
          },
          generate: {
            name: 'api.customer.brands.callback_urls.secrets.generate',
            method: 'post',
          },
        },
        update: {
          name: 'api.customer.brands.callback_urls.update',
          method: 'put',
        },
      },
      countries_currencies: {
        name: 'api.customer.brands.countries_currencies',
        method: 'get',
      },
      credentials: {
        delete: {
          name: 'api.customer.brands.credentials.delete',
          method: 'delete',
        },
        generate: {
          name: 'api.customer.brands.credentials.generate',
          method: 'post',
        },
        list: {
          name: 'api.customer.brands.credentials.list',
          method: 'get',
        },
        update: {
          name: 'api.customer.brands.credentials.update',
          method: 'put',
        },
      },
      currencies: {
        update: {
          name: 'api.customer.brands.currencies.update',
          method: 'post',
        },
      },
      games: {
        export: {
          name: 'api.customer.brands.games.export',
          method: 'get',
        },
        list: {
          name: 'api.customer.brands.games.list',
          method: 'get',
        },
      },
      list: {
        name: 'api.customer.brands.list',
        method: 'get',
      },
      provider_credentials: {
        index: {
          name: 'api.customer.brands.provider_credentials.index',
          method: 'get',
        },
      },
      providers: {
        export: {
          name: 'api.customer.brands.providers.export',
          method: 'get',
        },
        list: {
          name: 'api.customer.brands.providers.list',
          method: 'get',
        },
      },
      public_api: {
        endpoints: {
          name: 'api.customer.brands.public_api.endpoints',
          method: 'get',
        },
        test: {
          name: 'api.customer.brands.public_api.test',
          method: 'post',
        },
      },
      show: {
        name: 'api.customer.brands.show',
        method: 'get',
      },
    },
    companies: {
      name: 'api.customer.companies',
      method: 'get',
    },
    currencies: {
      index: {
        name: 'api.customer.currencies.index',
        method: 'get',
      },
    },
    dashboard: {
      gaming_analytics: {
        name: 'api.customer.dashboard.gaming_analytics',
        method: 'get',
      },
      geo_performance: {
        name: 'api.customer.dashboard.geo_performance',
        method: 'get',
      },
      top_games: {
        name: 'api.customer.dashboard.top_games',
        method: 'get',
      },
      top_providers: {
        name: 'api.customer.dashboard.top_providers',
        method: 'get',
      },
    },
    game_sessions: {
      show: {
        name: 'api.customer.game_sessions.show',
        method: 'get',
      },
    },
    invitations: {
      destroy: {
        name: 'api.customer.invitations.destroy',
        method: 'delete',
      },
      index: {
        name: 'api.customer.invitations.index',
        method: 'get',
      },
      resend: {
        name: 'api.customer.invitations.resend',
        method: 'post',
      },
      store: {
        name: 'api.customer.invitations.store',
        method: 'post',
      },
    },
    pending_invitations: {
      name: 'api.customer.pending_invitations',
      method: 'get',
    },
    permissions: {
      name: 'api.customer.permissions',
      method: 'get',
    },
    players: {
      game_sessions: {
        name: 'api.customer.players.game_sessions',
        method: 'get',
      },
      games: {
        name: 'api.customer.players.games',
        method: 'get',
      },
      lifetime_stats: {
        name: 'api.customer.players.lifetime_stats',
        method: 'get',
      },
      list: {
        name: 'api.customer.players.list',
        method: 'get',
      },
      show: {
        name: 'api.customer.players.show',
        method: 'get',
      },
      transactions: {
        name: 'api.customer.players.transactions',
        method: 'get',
      },
    },
    reports: {
      gambling_summary: {
        export: {
          name: 'api.customer.reports.gambling_summary.export',
          method: 'post',
        },
        index: {
          name: 'api.customer.reports.gambling_summary.index',
          method: 'get',
        },
      },
      games: {
        index: {
          name: 'api.customer.reports.games.index',
          method: 'get',
        },
        trend: {
          name: 'api.customer.reports.games.trend',
          method: 'get',
        },
      },
      players: {
        export: {
          name: 'api.customer.reports.players.export',
          method: 'post',
        },
        index: {
          name: 'api.customer.reports.players.index',
          method: 'get',
        },
      },
      promotions: {
        export: {
          name: 'api.customer.reports.promotions.export',
          method: 'post',
        },
        index: {
          name: 'api.customer.reports.promotions.index',
          method: 'get',
        },
      },
    },
    roles: {
      destroy: {
        name: 'api.customer.roles.destroy',
        method: 'delete',
      },
      index: {
        name: 'api.customer.roles.index',
        method: 'get',
      },
      permissions: {
        name: 'api.customer.roles.permissions',
        method: 'get',
      },
      show: {
        name: 'api.customer.roles.show',
        method: 'get',
      },
      store: {
        name: 'api.customer.roles.store',
        method: 'post',
      },
      update: {
        name: 'api.customer.roles.update',
        method: 'put',
      },
      users: {
        assign: {
          name: 'api.customer.roles.users.assign',
          method: 'post',
        },
        index: {
          name: 'api.customer.roles.users.index',
          method: 'get',
        },
        remove: {
          name: 'api.customer.roles.users.remove',
          method: 'delete',
        },
      },
    },
    search: {
      name: 'api.customer.search',
      method: 'get',
    },
    settings: {
      show: {
        name: 'api.customer.settings.show',
        method: 'get',
      },
      update: {
        name: 'api.customer.settings.update',
        method: 'put',
      },
    },
    transactions: {
      audit_logs: {
        name: 'api.customer.transactions.audit_logs',
        method: 'get',
      },
      dashboard: {
        name: 'api.customer.transactions.dashboard',
        method: 'get',
      },
      details: {
        name: 'api.customer.transactions.details',
        method: 'get',
      },
      index: {
        name: 'api.customer.transactions.index',
        method: 'get',
      },
      recent: {
        name: 'api.customer.transactions.recent',
        method: 'get',
      },
      reports: {
        generate: {
          name: 'api.customer.transactions.reports.generate',
          method: 'post',
        },
      },
      retry: {
        name: 'api.customer.transactions.retry',
        method: 'post',
      },
      round_details_url: {
        name: 'api.customer.transactions.round_details_url',
        method: 'get',
      },
      stats: {
        name: 'api.customer.transactions.stats',
        method: 'get',
      },
    },
    users: {
      index: {
        name: 'api.customer.users.index',
        method: 'get',
      },
      permissions: {
        update: {
          name: 'api.customer.users.permissions.update',
          method: 'patch',
        },
      },
      roles: {
        update: {
          name: 'api.customer.users.roles.update',
          method: 'patch',
        },
      },
      show: {
        name: 'api.customer.users.show',
        method: 'get',
      },
    },
  },
  docs: {
    index: {
      name: 'api.docs.index',
      method: 'get',
    },
    section: {
      name: 'api.docs.section',
      method: 'get',
    },
    versions: {
      name: 'api.docs.versions',
      method: 'get',
    },
  },
  invitations: {
    accept: {
      name: 'api.invitations.accept',
      method: 'post',
    },
    reject: {
      name: 'api.invitations.reject',
      method: 'post',
    },
    show: {
      name: 'api.invitations.show',
      method: 'get',
    },
  },
  public_api: {
    documentation: {
      name: 'api.public_api.documentation',
      method: 'get',
    },
  },
  timezones: {
    name: 'api.timezones',
    method: 'get',
  },
  translations: {
    all: {
      name: 'api.translations.all',
      method: 'get',
    },
    for_locale: {
      name: 'api.translations.for_locale',
      method: 'get',
    },
  },
} as const;

/**
 * Union type of all valid api route names
 */
export type RouteName = AllRouteConfigs['name'];

/**
 * Type-safe api API request function
 *
 * Parameter validation is handled by ESLint plugin 'route-validation/validate-route-params'
 *
 * @example
 * // Route without URL params
 * await apiRequest(API_ROUTES.admin.dashboard);
 *
 * // Route with URL params
 * await apiRequest(API_ROUTES.customer.dashboard, { companyId: '123' });
 *
 * // With request body
 * await apiRequest(API_ROUTES.customer.users.create, { companyId: '123' }, { name: 'John' });
 */
export function apiRequest<TResponse = unknown>(
  config: AllRouteConfigs,
  params?: unknown,
  data?: unknown,
  axiosConfig?: AxiosRequestConfig,
): Promise<Result<TResponse>> {
  return createApiRequest<TResponse, AllRouteConfigs>(config, params, data, axiosConfig);
}

export type { Result, HttpMethod } from './api-shared';
export { ApiError, ValidationError, SchemaValidationError, RouteError, UnauthorizedError, ForbiddenError, NotFoundError, ServerError, validatedApiRequest } from './api-shared';
